import { IEvent, dispatcher, toInt ,ingenuity} from "@quest/base-core";
import { FreeGameReelPanelControllerBehavior, SoundConstant } from "@quest/murka-games-behavior-leopard/dist"

import { eventDispatchers } from "../Constants/EventDispatchers";
import { GameParserModel } from "../Platform/GameParserModel";
export class FreeGameReelPanelControllerGame extends FreeGameReelPanelControllerBehavior {
    /**
     * to subscribe reel hide
     */
    protected subscribeEvents(): void {
        super.subscribeEvents();
        dispatcher.on(eventDispatchers.HIDE_REEL_BEHIND_WILD_FG, this.hideAnimReelBehindWildFG, this);
    }
    /**
     * to unsubscribe reel hide
     */
    protected unsubscribeEvents(): void {
        super.unsubscribeEvents();
        dispatcher.off(eventDispatchers.HIDE_REEL_BEHIND_WILD_FG, this.hideAnimReelBehindWildFG, this);
    }

    /**
 * function will hide a particular reel behind the wild symbol to avoid spinning
 */
    private hideAnimReelBehindWildFG(evt: IEvent): void {
        this.reelView.getAnimReels()[evt.data].visible = false;
    }
    /**
     * to stop wild locked reel's stop sound
     */
    protected  onReelStopping(evt:IEvent) {
        this.view.clearAnticipation();
        const wildArray = (ingenuity.parserModel as GameParserModel).getWildLockPos()[(ingenuity.parserModel as GameParserModel).getPickChoice()]
        const value = (ingenuity.parserModel as GameParserModel).getLandingSoundOnReel()[0][toInt(evt.toString())];
        if (value === undefined && !this.model.getIsTurboModeOn() && !wildArray.includes(toInt(evt.toString())+1)) {
            (ingenuity.soundManager as any).playSound(SoundConstant.REEL_STOP, 0.8, false, "soundList");
        }
        if (this.model.getIsTurboModeOn() && (toInt(evt.toString()) === 0)) {
            (ingenuity.soundManager as any).playSound(SoundConstant.REEL_STOP, 0.8, false, "soundList");
        }
    }
}

